var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{style:({
    'pointer-events': _vm.obj.pointerEvents,
  })},[_c('circle',{attrs:{"r":"20","stroke":"blue","stroke-width":"5","fill":"transparent","data-id":_vm.obj.id}}),_c('circle',{attrs:{"r":"10","fill":"blue","data-id":_vm.obj.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }